import type { Dispatch, FC, RefObject, SetStateAction } from 'react';
import { Button } from '@/DesignSystem/Component';
import Datepicker from '@/Module/Auth/Component/DatepickerInput/Datepicker';
import ThemeDrawer from '@/Module/Auth/Component/ThemeDrawer/ThemeDrawer';
import type { IDatepickerIImperativeHandleResult } from '@/Module/Auth/Model/DataModel';
import { IconCloseProfile } from '@/Module/Icon';
import { IconBirthDate } from '@/Module/Icon/Component/IconBirthDate';
interface IDatepickerDrawerProps {
  isOpen: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  datepickerRef: RefObject<IDatepickerIImperativeHandleResult>;
}
const DatepickerDrawer: FC<IDatepickerDrawerProps> = ({
  isOpen,
  setOpen,
  datepickerRef
}) => {
  const handleClose = () => {
    setOpen(false);
  };
  return <ThemeDrawer isOpen={isOpen} setOpen={handleClose} data-sentry-element="ThemeDrawer" data-sentry-component="DatepickerDrawer" data-sentry-source-file="DatepickerDrawer.tsx">
      <Button onClick={handleClose} className="!absolute inset-x-0 -top-16" data-sentry-element="Button" data-sentry-source-file="DatepickerDrawer.tsx">
        <IconCloseProfile data-sentry-element="IconCloseProfile" data-sentry-source-file="DatepickerDrawer.tsx" />
      </Button>
      <span className="relative mx-auto mb-4 mt-2 flex h-[8px] w-[60px] justify-center rounded-lg  bg-blackSix" />
      <div className="mb-2 flex flex-row items-center justify-center">
        <IconBirthDate data-sentry-element="IconBirthDate" data-sentry-source-file="DatepickerDrawer.tsx" />
        <div className="text-2xl font-extrabold ">تاریخ تولد</div>
      </div>

      <Datepicker ref={datepickerRef} data-sentry-element="Datepicker" data-sentry-source-file="DatepickerDrawer.tsx" />
      <div className=" sticky bottom-0 left-0 z-10 w-full pb-4">
        <Button className="relative w-full" variant="shadow" color="primary" radius="circle" size="large" onClick={handleClose} data-sentry-element="Button" data-sentry-source-file="DatepickerDrawer.tsx">
          ثبت و تایید
        </Button>
      </div>
    </ThemeDrawer>;
};
export default DatepickerDrawer;